<template>
  <div class="advantage g_clr">
    <div class="inner">
      <h3>我们的优势</h3>
      <dl>
        <dt><span class="home_icons home_icon_1" /></dt>
        <dd class="tit">信息安全</dd>
        <dd class="desc">采用256位ssl加密传输技术让文件传输更安全更放心</dd>
      </dl>
      <dl>
        <dt><span class="home_icons home_icon_2" /></dt>
        <dd class="tit">超大文件任意转</dd>
        <dd class="desc">高效办公，最大支持50M文件，一键批量转换</dd>
      </dl>
      <dl>
        <dt><span class="home_icons home_icon_3" /></dt>
        <dd class="tit">高质量转换</dd>
        <dd class="desc">采用业内最新转换处理技术让文件处理效果更完美</dd>
      </dl>
      <dl class="last">
        <dt><span class="home_icons home_icon_4" /></dt>
        <dd class="tit">云端处理</dd>
        <dd class="desc">无需安装软件，网站在线即可轻松完成文件处理</dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Advantage'
}
</script>

<style lang="scss" scoped>
.advantage {
  padding-bottom: 110px;
  margin-top: 40px;
  text-align: center;
  background: rgba(249, 249, 249, 1);

  h3 {
    margin: 50px 0;
    font-size: 28px;
    font-weight: 400;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
  }

  dl {
    float: left;
    width: 238px;
    height: 257px;
    margin-right: 70px;
  }

  dd {
    padding: 10px 0;
  }

  .last {
    margin-right: 0;
  }

  .tit {
    font-size: 18px;
    font-weight: 500;
  }

  .desc {
    color: #666;
    text-align: left;
  }
}
</style>
